import { UserServiceTypes, RECEIVE_USER_SEVICES, REQUEST_USER_SEVICES,
     WrittenInstructionTimestampTypes, ADD_WRITTEN_INSTRUCTION_TIMESTAMP, WRITTEN_INSTRUCTION_TIMESTAMP_LOADER
     } from "./types";
import { AppThunkAction } from "..";
import { getUserService, postLegacyWrittenInstructionTimestamp } from "../service";

export const actionCreators = {
    requestUserService:
        (isForceCall = false): AppThunkAction<UserServiceTypes> =>
        (dispatch, getState) => {
            const appSate = getState();
            if (!isForceCall && appSate && appSate.userServiceState && appSate.userServiceState.serviceCategories) {
                return;
            }

            getUserService()
                .then((data) => {
                    if (data && data["isSuccess"] && data["serviceCategories"]) {
                        dispatch({ type: RECEIVE_USER_SEVICES, serviceCategories: data["serviceCategories"] });
                    } else {
                        dispatch({ type: RECEIVE_USER_SEVICES });
                    }
                    sessionStorage.setItem('reloadUserServices', JSON.stringify(false));
                })
                .catch((error) => {
                    dispatch({ type: RECEIVE_USER_SEVICES });
                });

            dispatch({ type: REQUEST_USER_SEVICES });
        },

    addLegacyWrittenInstructionTimestamp: (): AppThunkAction<WrittenInstructionTimestampTypes> =>
        (dispatch, getState) => {
            dispatch({ type: WRITTEN_INSTRUCTION_TIMESTAMP_LOADER, isAddWrittenTimestampLoading: true });
            postLegacyWrittenInstructionTimestamp()
                .then((data) => {
                    dispatch({ type: WRITTEN_INSTRUCTION_TIMESTAMP_LOADER, isAddWrittenTimestampLoading: false });
                    if (data && data["isSuccess"]) {
                        dispatch({ type: ADD_WRITTEN_INSTRUCTION_TIMESTAMP, timestamp: '123' });
                    }
                })
                .catch((error) => {
                    dispatch({ type: WRITTEN_INSTRUCTION_TIMESTAMP_LOADER, isAddWrittenTimestampLoading: false });
                });

           
        },
};
